import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BookingItemProps } from "apis/booking";
import { PaginationProps } from "utils/types/API";

export interface BookingState {
    loading: boolean;
    list: {
        data: BookingItemProps[];
        pagination?: PaginationProps;
    };
    item: {
        data?: BookingItemProps;
    };
}

const initialState: BookingState = {
    loading: false,
    list: {
        data: []
    },
    item: {
    }
};

interface IndexProps {
    data: BookingItemProps[];
    pagination?: PaginationProps;
}
interface ItemProps {
    data?: BookingItemProps;
}
export const bookingSlice = createSlice({
    name: "booking",
    initialState,
    reducers: {
        loading: (state) => {
            state.loading = true;
        },
        endLoading: (state) => {
            state.loading = false;
        },
        index: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.data = action.payload.data;
            state.list.pagination = action.payload.pagination;
        },
        find: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        create: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        update: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
            state.list.data = state.list.data.map(item => item.id === action.payload.data?.id ? action.payload.data : item);
        },
    },
});

export const { loading, endLoading, index, find, create, update } = bookingSlice.actions;
export default bookingSlice.reducer;
